"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceInput = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var Typo_1 = require("../Typo");
var bannerContext_1 = require("../Banners/bannerContext");
var icons_1 = require("../../icons");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var ResourceDisplayBlock_1 = require("./comp/ResourceDisplayBlock");
var styled_1 = require("./styled");
var useFakeUploadImpression_1 = require("../../utilsOolib/useFakeUploadImpression");
var utilsOolib_1 = require("../../utilsOolib");
var themes_1 = require("../../themes");
var Plus = icons_1.icons.Plus;
var ResourceInput = function (props) {
    var parentOnChange = props.onChange, comp_id = props.id, _a = props.folderName, folderName = _a === void 0 ? "media" : _a, value = props.value, _b = props.multiple, multiple = _b === void 0 ? true : _b, uploadBtnText = props.uploadBtnText, readOnly = props.readOnly, invert = props.invert;
    var theme = (0, styled_components_1.useTheme)();
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var _c = (0, react_1.useState)(undefined), uploadProgress = _c[0], setUploadProgress = _c[1];
    var _d = (0, react_1.useState)(0), filesLength = _d[0], setFilesLength = _d[1];
    var _e = (0, react_1.useState)(value ? __spreadArray([], value, true) : []), resources = _e[0], setResources = _e[1];
    var handleUploadProgess = function (progress) { return setUploadProgress(progress); };
    var upload = ((theme === null || theme === void 0 ? void 0 : theme.useUploadMedia({
        mediaConfigs: {
            type: "files",
            folderName: folderName,
            mediaType: "resources",
        },
        handleUploadProgess: handleUploadProgess,
    })) ||
        (0, useFakeUploadImpression_1.useFakeUploadImpression)({ handleUploadProgess: handleUploadProgess, fileType: "resource" })).mutate;
    var inputRef = (0, react_1.useRef)();
    var handleUpload = function (files) {
        if (!files)
            return;
        if (!upload)
            return;
        setFilesLength(files === null || files === void 0 ? void 0 : files.length);
        upload(files, {
            onSuccess: function (data) {
                var successfulUploads = data // In case of multiple file uploads, there is possiblity of one file failing
                    .filter(function (d) { return d.status === "success"; })
                    .map(function (d) { return d.fileData; });
                var failedUploads = data
                    .filter(function (d) { return d.status === "error"; })
                    .map(function (d) { return d.message; });
                failedUploads && failedUploads.map(function (msg) { return SET_ALERT_BANNER(msg, "red", 3500); });
                setResources(function (prevResources) {
                    var newResources = __spreadArray(__spreadArray([], prevResources, true), successfulUploads, true);
                    return newResources;
                });
                parentOnChange(comp_id, resources);
                setFilesLength(0);
            },
            onError: function (err) {
                var _a;
                SET_ALERT_BANNER(((_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors[0].msg) || err.message, "red", 3500);
                setFilesLength(0);
            },
        });
    };
    var removeResource = function (id) {
        var newResources = resources.filter(function (d) { return d.id !== id; });
        setResources(newResources);
        parentOnChange && parentOnChange(props.id, newResources);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement(styled_1.StyledWrapper, null,
            react_1.default.createElement(ResourceDisplayBlock_1.ResourceDisplayBlock, { resources: resources, filesLength: filesLength, uploadProgress: uploadProgress, invert: invert, removeResource: function (id) { return removeResource(id); } }),
            !readOnly &&
                react_1.default.createElement(styled_1.StyledUploadButton, { onClick: function () { return inputRef.current.click(); }, invert: invert, theme: theme },
                    react_1.default.createElement(Plus, { color: invert ? (0, utilsOolib_1.getPrimaryColor40)(themes_1.colors) : (0, utilsOolib_1.getPrimaryColorText)(themes_1.colors), size: 20, weight: 'bold', "style-": { border: 'none' } }),
                    react_1.default.createElement(Typo_1.SANS_3, { semibold: true, style: { marginTop: '0.5rem' } }, uploadBtnText || "Add Resource"))),
        react_1.default.createElement("input", { id: "".concat(comp_id, "_resources_uploader"), type: "file", multiple: multiple, style: { display: 'none' }, ref: inputRef, onChange: function (v) { return handleUpload(v.target.files); } })));
};
exports.ResourceInput = ResourceInput;
